import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { melde_an } from './anmeldung'
import './stil.css'

const wurzel = createRoot(document.getElementById('wurzel')!)

melde_an()
  .then((angemeldet) => {
    if (!angemeldet) {
      wurzel.render(
        <div className="inhalt">
          <h1>Nicht angemeldet</h1>
          <p className="untertitel">
            Die Anmeldung wurde abgebrochen. Bitte die Seite neu laden.
          </p>
        </div>,
      )
      return
    }
    wurzel.render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    )
  })
  .catch((ursache: unknown) => {
    wurzel.render(
      <div className="inhalt">
        <h1>Anmeldedienst nicht erreichbar</h1>
        <p className="untertitel">
          Der Anmeldedienst antwortet nicht: {String(ursache)}. Für den örtlichen
          Betrieb ohne Keycloak kann <code>VITE_ANMELDUNG_AUS=true</code> gesetzt werden.
        </p>
      </div>,
    )
  })
